const ROLE_ALIASES = {
  CNA: "CNA",
  "CERTIFIED NURSING ASSISTANT": "CNA",

  LVN: "LVN",
  LPN: "LVN",
  "LICENSED VOCATIONAL NURSE": "LVN",
  "LICENSED PRACTICAL NURSE": "LVN",

  RN: "RN",
  "REGISTERED NURSE": "RN",

  MED: "MED_AIDE",
  "MED AIDE": "MED_AIDE",
  "MEDICATION AIDE": "MED_AIDE",
  "MEDICATION TECHNICIAN": "MED_AIDE",

  CARE: "CAREGIVER",
  CAREGIVER: "CAREGIVER",
};

export function normalizeWorkerRole(value) {
  const key = String(value || "")
    .trim()
    .toUpperCase();

  return ROLE_ALIASES[key] || key || "";
}

export function getWorkerRoles(worker = {}) {
  const candidates = [
    ...(Array.isArray(worker.roles) ? worker.roles : []),
    ...(Array.isArray(worker.positions) ? worker.positions : []),
    worker.primaryRole,
    worker.position,
    worker.workerType,
  ];

  return Array.from(
    new Set(
      candidates
        .map(normalizeWorkerRole)
        .filter(Boolean)
    )
  );
}

export function getWorkerPrimaryRole(worker = {}) {
  const explicitPrimary = normalizeWorkerRole(worker.primaryRole);

  if (explicitPrimary) {
    return explicitPrimary;
  }

  return getWorkerRoles(worker)[0] || "";
}

export function workerCanFillRole(worker, shiftRole) {
  const requiredRole = normalizeWorkerRole(shiftRole);

  if (!requiredRole) {
    return false;
  }

  return getWorkerRoles(worker).includes(requiredRole);
}